import { Button, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, FormControl, FormLabel, Input, Textarea, Select, Option, Alert, Sheet, CircularProgress } from "@mui/joy";
import { useState, useContext, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LayoutContext } from "../../context";
import { APICreateTechSupportTicket } from "../../api";



export default function ModalTechSupport() {
  const { account, tokenEmployee, modalTicketSupport, setModalTicketSupport } = useContext(LayoutContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  
  // Данные формы
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    priority: "improve" // По умолчанию "Улучшить"
  });

  // Приоритеты обращений
  const priorityOptions = [
    { value: "fix", label: "Исправить", color: "danger", description: "Критическая ошибка, мешает работе" },
    { value: "improve", label: "Улучшить", color: "primary", description: "Предложение по улучшению функционала" },
    { value: "important", label: "Важно", color: "warning", description: "Важный вопрос, требует внимания" }
  ];

  useEffect(() => {
    setSuccess(false);
    setError("");
  }, []);

//   const handleOpen = () => {
//     setModalTicketSupport(true);
//     setSuccess(false);
//     setError("");
//   };

  const handleClose = () => {
    setModalTicketSupport(false);
    setFormData({
      title: "",
      description: "",
      priority: "improve"
    });
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    // Валидация
    if (!formData.title.trim()) {
      setError("Заголовок обращения обязателен");
      return;
    }
    
    if (!formData.description.trim()) {
      setError("Описание проблемы обязательно");
      return;
    }
    
    if (formData.title.length < 5) {
      setError("Заголовок должен содержать минимум 5 символов");
      return;
    }
    
    if (formData.description.length < 10) {
      setError("Описание должно содержать минимум 10 символов");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const ticketData = {
        title: formData.title,
        description: formData.description,
        priority: formData.priority,
        employee: account?.id // ID Исполнителя из контекста
      };

      const response = await APICreateTechSupportTicket(ticketData, tokenEmployee);
      
      if (response.status === 'ok') {
        setSuccess(true);
        // Сброс формы через 2 секунды
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 2000);
      } else {
        setError(response.message || "Ошибка при создании обращения");
      }
    } catch (err) {
      setError("Произошла ошибка при отправке обращения");
      console.error("Error creating tech support ticket:", err);
    } finally {
      setLoading(false);
    }
  };

  const getPriorityColor = (priority) => {
    const priorityMap = {
      "fix": "danger",
      "improve": "primary",
      "important": "warning"
    };
    return priorityMap[priority] || "primary";
  };

  const getPriorityDescription = (priority) => {
    const option = priorityOptions.find(opt => opt.value === priority);
    return option?.description || "";
  };

  return (
    <>
      {/* Кнопка в правом нижнем углу */}
      {/* <Button
        onClick={handleOpen}
        variant="solid"
        color="primary"
        size="lg"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 10000, // Выше всех элементов
          borderRadius: '50%',
          width: 60,
          height: 60,
          boxShadow: 'lg',
          '&:hover': {
            boxShadow: 'xl',
            transform: 'scale(1.05)'
          },
          transition: 'all 0.2s ease'
        }}
      >
        <Typography level="h4">🛠️</Typography>
      </Button> */}

      <AnimatePresence>
        {modalTicketSupport && (
          <Modal
            sx={{ zIndex: 10100 }}
            open={modalTicketSupport}
            onClose={handleClose}
            slotProps={{
              backdrop: {
                component: motion.div,
                initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                transition: { duration: 0.3, ease: "easeInOut" },
              }
            }}
          >
            <ModalOverflow sx={{ height: 'auto' }}>
              <ModalDialog
                size="lg"
                component={motion.div}
                initial={{ opacity: 0, y: -10, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10, scale: 0.98 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                sx={(theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    width: '95%',
                    p: 3,
                  },
                  width: '600px'
                })}
              >
                <ModalClose onClick={handleClose}/>
                
                {success ? (
                  <Stack spacing={3} alignItems="center" textAlign="center">
                    <Alert color="success" size="md" sx={{ width: '100%' }}>
                      <Typography level="h4">✅ Обращение успешно создано!</Typography>
                    </Alert>
                    <Typography level="body-md">
                      Наша команда техподдержки рассмотрит ваше обращение в ближайшее время.
                    </Typography>
                    <CircularProgress size="sm" />
                    <Typography level="body-sm" color="neutral">
                      Модальное окно закроется автоматически...
                    </Typography>
                  </Stack>
                ) : (
                  <>
                    <Typography sx={{ textAlign: 'center', mb: 2 }} level="h4">
                      📝 Обращение в техподдержку
                    </Typography>
                    
                    <Typography level="body-md" sx={{ mb: 0, textAlign: 'center' }}>
                      Опишите вашу проблему или предложение по улучшению системы
                    </Typography>
                    
                    {error && (
                      <Alert color="danger" sx={{ mb: 2 }}>
                        {error}
                      </Alert>
                    )}
                    
                    <Stack spacing={3}>
                      {/* Заголовок */}
                      <FormControl>
                        <FormLabel>
                          <Stack direction='column' spacing={0.5}>
                            <Typography level="title-lg">Заголовок обращения</Typography>
                            <Typography level="body-xs" color="primary">
                                Кратко опишите суть проблемы или предложения
                            </Typography>
                          </Stack>
                        </FormLabel>
                        <Input 
                          value={formData.title}
                          onChange={(e) => handleChange('title', e.target.value)}
                          placeholder="Например: Проблема с загрузкой файлов на Яндекс.Диск"
                          size="md"
                          sx={{ mt: 1, borderRadius: 'lg' }}
                        />
                        <Typography level="body-xs" color="neutral" sx={{ mt: 0.5 }}>
                          Осталось символов: {Math.max(0, 100 - formData.title.length)}
                        </Typography>
                      </FormControl>
                      
                      {/* Приоритет */}
                      <FormControl>
                        <FormLabel>
                          <Typography level="title-lg">Приоритет обращения</Typography>
                        </FormLabel>
                        <Select
                          value={formData.priority}
                          onChange={(e, value) => handleChange('priority', value)}
                          size="md"
                          sx={{ mt: 1, borderRadius: 'lg' }}
                          slotProps={{ listbox: { sx: { width: '100%', zIndex: 10101, borderRadius: 'lg' }}}}
                        >
                          {priorityOptions.map((option) => (
                            <Option key={option.value} value={option.value}>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <Typography color={option.color}>
                                  {option.label}
                                </Typography>
                              </Stack>
                            </Option>
                          ))}
                        </Select>
                        <Typography level="body-sm" color={getPriorityColor(formData.priority)} sx={{ mt: 1 }}>
                          {getPriorityDescription(formData.priority)}
                        </Typography>
                      </FormControl>
                      
                      {/* Описание */}
                      <FormControl>
                        <FormLabel>
                          <Typography level="title-lg">Подробное описание</Typography>
                          <Typography level="body-xs" color='primary'>
                            Опишите проблему максимально подробно. Укажите шаги воспроизведения, 
                            приложите скриншоты если возможно.
                          </Typography>
                        </FormLabel>
                        <Textarea 
                          value={formData.description}
                          onChange={(e) => handleChange('description', e.target.value)}
                          size="md"
                          minRows={6}
                          placeholder={`1. Что произошло?\n2. Какие действия выполняли?\n3. Каков ожидаемый результат?\n4. Что получилось вместо этого?\n\nПри необходимости укажите:\n- ID сделки/события\n- Браузер и устройство\n- Дата и время возникновения проблемы`}
                          sx={{ mt: 1, borderRadius: 'lg' }}
                        />
                        <Typography level="body-xs" color="neutral" sx={{ mt: 0.5 }}>
                          Минимум 10 символов. Осталось: {Math.max(0, 10 - formData.description.length)}
                        </Typography>
                      </FormControl>
                      
                      {/* Информация о пользователе */}
                      <Sheet variant="soft" color="neutral" sx={{ p: 2, borderRadius: 'md' }}>
                        <Typography level="body-sm">
                          <strong>Информация о вас:</strong><br />
                          Исполнитель: {account?.name || "Не указан"}<br />
                          Должность: {account?.name_position || "Не указана"}<br />
                          Город: {account?.city || "Не указан"}
                        </Typography>
                      </Sheet>
                      
                      {/* Кнопки действий */}
                      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <Button 
                          onClick={handleSubmit} 
                          loading={loading} 
                          size="md" 
                          variant="solid" 
                          color="primary"
                          disabled={!formData.title.trim() || !formData.description.trim()}
                          sx={{ flex: 1 }}
                        >
                          Отправить обращение
                        </Button>
                        
                        <Button 
                          onClick={handleClose} 
                          size="md" 
                          variant="outlined" 
                          color="neutral"
                          disabled={loading}
                        >
                          Отмена
                        </Button>
                      </Stack>
                      
                      {/* <Typography level="body-xs" color="neutral" sx={{ textAlign: 'center', mt: 2 }}>
                        Обращения обрабатываются в рабочее время (Пн-Пт, 9:00-18:00)
                      </Typography> */}
                    </Stack>
                  </>
                )}
              </ModalDialog>
            </ModalOverflow>
          </Modal>
        )}
      </AnimatePresence>
    </>
  );
}